module.exports = __webpack_public_path__ + "img/甲板.53a079ae.jpg";